import React from 'react'
import config from '../config';
import ajaxcall from '../utils/ajaxcall';

function Tag(props) {
    const [Tag, setTag] = React.useState(null);
    React.useEffect(() => {
        async function fetchData() {
            let apiCall = await ajaxcall.getCall(`${config.api.generic}/tag`, {}, props.token);
            if(apiCall && apiCall.status) {
                setTag(apiCall.context.data);
            }
        }
        fetchData();
    }, []); 

    const handleChange=((val)=>{ 
        props.locationFunction('tagId', val.target.value) 
    })

    if (!Tag) return <div className="text-primary">Loading tag values</div>;
    return (
        <>
            <select {...props.register("tagId", { required: false })} value={props.selectedValue} className="form-control custom-select" onChange={handleChange} >
                <option value={0}> Choose...</option>
                {(Tag) ? Tag.map((element) => { 
                    return (<option key={Math.random()} value={element.id}>{element.label}</option>)
                }) : ''}
            </select>
            <small className="form-text text-danger">
                {props.errors.tagId?.type === "required" && "Tag is mandatory"}
            </small>
        </>
    )
}
export default Tag;